import Siema from 'siema';
import { createCarouselDots } from './carouselUtils';

const removePreviousDots = carousel => {
  const dots = carousel.selector.parentElement.querySelector('.carousel-dots');
  dots?.remove();
};

const removePreviousArrows = carousel => {
  const prev = carousel.selector.parentElement.querySelector('.product-carousel__prev');
  prev?.remove();
  const next = carousel.selector.parentElement.querySelector('.product-carousel__next');
  next?.remove();
};

function addPagination(carousel) {
  removePreviousDots(carousel);
  const dots = createCarouselDots(carousel);
  carousel.selector.parentElement.appendChild(dots);
}

function addArrows(carousel) {
  removePreviousArrows(carousel);

  carousel.prevArrow = document.createElement('button');
  carousel.prevArrow.setAttribute('aria-label', 'previous');
  carousel.prevArrow.classList.add('product-carousel__prev');
  carousel.selector.parentElement.appendChild(carousel.prevArrow);
  const arrowLeft = document.createElement('i');
  arrowLeft.classList.add('fa-light', 'fa-chevron-left');
  carousel.prevArrow.appendChild(arrowLeft);
  carousel.prevArrow.addEventListener('click', () => carousel.prev());

  carousel.nextArrow = document.createElement('button');
  carousel.nextArrow.setAttribute('aria-label', 'next');
  carousel.nextArrow.classList.add('product-carousel__next');
  carousel.selector.parentElement.appendChild(carousel.nextArrow);
  const arrowRight = document.createElement('i');
  arrowRight.classList.add('fa-light', 'fa-chevron-right');
  carousel.nextArrow.appendChild(arrowRight);
  carousel.nextArrow.addEventListener('click', () => carousel.next());
}

export default function createCarousel(element, options) {
  const carousel = new Siema({
    selector: element,
    loop: true,
    perPage: 1,
    duration: 500,
    ...options,
    onChange() {
      element.dispatchEvent(new CustomEvent('change'));
      if (options.onChange) {
        options.onChange();
      }
    },
    onInit() {
      addArrows(this);
      addPagination(this);
    },
  });

  const resizeHandler = () => {
    addArrows(carousel);
    addPagination(carousel);
  };

  window.addEventListener('resize', resizeHandler);

  return Object.assign(carousel, {
    destroyCarousel(restoreMarkup, callback) {
      removePreviousArrows(this);
      removePreviousDots(this);
      window.removeEventListener('resize', resizeHandler);
      carousel.destroy(restoreMarkup, callback);
    },
  });
}
